import { render, staticRenderFns } from "./chatRoom.vue?vue&type=template&id=626e7028&scoped=true&"
import script from "./chatRoom.vue?vue&type=script&lang=js&"
export * from "./chatRoom.vue?vue&type=script&lang=js&"
import style0 from "./chatRoom.vue?vue&type=style&index=0&id=626e7028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e7028",
  null
  
)

export default component.exports